import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import AppRoutes from './routes/AppRoutes';
import './assets/styles/App.css';

// Debug: Check environment variables
// console.log('Environment Variables:', {
//     USE_MOCK_API: process.env.REACT_APP_USE_MOCK_API,
//     API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
//     APP_NAME: process.env.REACT_APP_APP_NAME,
//     NODE_ENV: process.env.NODE_ENV
// });

function App() {
    return (
        <AuthProvider>
            <NotificationProvider>
                <Router>
                    <div className="App">
                        <AppRoutes />
                    </div>
                </Router>
            </NotificationProvider>
        </AuthProvider>
    );
}

export default App;